import React from 'react';
import {makeStyles} from "@material-ui/core/styles";
import {Button, FormControl, FormLabel} from "@material-ui/core";
import {ResetIcon} from '../../../helpers/Icons'
import ListFilter from "./ListFilter";
import {ExpandLess} from "@mui/icons-material";
import CloseIcon from "@mui/icons-material/Close";

const useStyles = makeStyles(theme => ({

  filterControls: {
    display: 'flex',
    marginTop: '1em',
    padding: '0em 1em 1em',
    border: '1px solid rgba(0, 0, 0, 0.23)',
    borderRadius: '4px',
    overflow: 'visible',
    position: 'relative',
    backgroundColor: '#ffffff'
  },
  label: {
    flexShrink: 0,
    fontSize: '0.85rem',
    // padding: '0 4px',
    marginTop:'-12px',
    position: 'absolute',
    backgroundColor: 'inherit',
    borderRadius: '4px',
    border: '1px solid rgba(0, 0, 0, 0)',
    '&:hover': {
      border: '1px solid rgba(0, 0, 0, 0.23)',
    },
    '&> button':{
      // textTransform: 'none',
      padding: '0px 4px',
      fontWeight: 500,
      fontSize: '0.85em',
    }
  },
  buttonBox: {
    flexGrow: 1,
    flexBasis: '100%',
    marginRight:'auto',
    alignSelf: 'start',
    textAlign: 'start',
    display: 'flex',
    flexWrap: 'wrap',
    gap: '0.5em',
    marginTop: '0.5em'
  },
  resetButton: {
    flexShrink: 0,
    fontSize: '0.7225rem',
    height: '2.75em',
    alignSelf: 'end',
    padding: '0 1em',
    minWidth: '150px',
  },

  filterField: {
    minWidth: 150,
    // margin: '1em 1em 0 0',
  },
  filterBox: {
    flex: 1,
  },
  filterWrapper: {
    width: "100%",
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: 'space-between',
    gap: '1em',
    paddingTop: '1em',
  },
}));

function DataFilters(props) {
  const { open, setOpen, filters, filterSelections, clearFilterSelections, mindfileFilterValues } = props;
  const classes = useStyles();

  const renderFiltersBox = () => {
    return filters.length > 0 ? (
      <>
          <FormControl id="filtersMenu" className={classes.filterControls}>
            <FormLabel className={classes.label} component="div">
              <Button onClick={() => setOpen(!open)}>Filters<ExpandLess size="small" variant="outlined" style={{fontSize: '1rem'}} /></Button>
            </FormLabel>
            <div className={classes.filterWrapper}>
              {filters.map((filter, index) => filter.enabled && filter.visible ? (
                <ListFilter
                  key={filter.label}
                  label={filter.label}
                  filterList={filter.options(mindfileFilterValues)}
                  selectedItems={filterSelections[index].selectedItems}
                  handleSelect={e => filter.handleSelect(e.target.value)}
                />
              )
              : null )}
            </div>
            <div className={classes.buttonBox}>
              <Button
                className={classes.resetButton}
                variant="outlined"
                onClick={clearFilterSelections}
                startIcon={<ResetIcon />}
              >
                Clear Filters
              </Button>
              <Button
                onClick={() => setOpen(!open)}
                className={classes.resetButton}
                variant="outlined"
                startIcon={<CloseIcon />}
              >
                Close
              </Button>
            </div>
          </FormControl>
      </>
    ) : null;
  }

  return (
    <>
      {renderFiltersBox()}
    </>
  );
}

export default DataFilters;
